import React from "react";
import { useNavigate } from "react-router-dom";
import { CrudPage } from "@/components/CrudPage";
import { StatusBadge } from "@/components/StatusBadge";
import { useI18n } from "@/context/I18nContext";

export default function Landlords() {
  const navigate = useNavigate();
  const { t } = useI18n();

  const TYPE_MAP = {
    individual: { label: t("個人"), tone: "blue" },
    corporate: { label: t("法人"), tone: "green" },
  };

  const columns = [
    { key: "login_code", label: t("コード"), render: (r) => <span className="font-mono text-xs text-muted-foreground">{r.login_code || "-"}</span> },
    { key: "name", label: t("貸主名"), render: (r) => <span className="font-medium text-[#0A0A0A]">{r.name || r.company_name || "-"}</span> },
    { key: "account_type", label: t("区分"), render: (r) => <StatusBadge value={r.account_type || "individual"} map={TYPE_MAP} /> },
    { key: "phone", label: t("電話番号"), render: (r) => <span className="text-muted-foreground">{r.phone || "-"}</span> },
    { key: "email", label: t("メール"), render: (r) => <span className="text-muted-foreground">{r.email || "-"}</span> },
    { key: "portal_active", label: t("ポータル"), render: (r) => r.portal_active ? <span className="text-green-600 text-xs">{t("有効")}</span> : <span className="text-gray-400 text-xs">{t("未設定")}</span> },
  ];

  const fields = [
    { name: "name", label: t("貸主名"), required: true },
    { name: "account_type", label: t("区分"), type: "select", options: [{ value: "individual", label: t("個人") }, { value: "corporate", label: t("法人") }], default: "individual" },
    { name: "phone", label: t("電話番号") },
    { name: "email", label: t("メールアドレス") },
    { name: "postal_code", label: t("郵便番号") },
    { name: "current_address", label: t("住所"), colSpan: 2 },
    { name: "note", label: t("備考"), type: "textarea" },
  ];

  return (
    <CrudPage
      title={t("貸主管理")}
      subtitle={t("物件オーナー（貸主）の一覧・登録")}
      endpoint="/landlords"
      resource="landlords"
      columns={columns}
      fields={fields}
      testid="landlords"
      addLabel={t("貸主を登録")}
      onView={(r) => navigate(`/landlords/${r.id}`)}
      searchKeys={["name", "phone", "email", "login_code"]}
    />
  );
}
